export const ERROR_MSG = {
  uploadFileErrorMsg: "uploadFileErrorMsg",
  sasURLErrorMsg: "sasURLErrorMsg",
  maliciousFileStatusError: "maliciousFileStatusError",
  maliciousEndResult: "maliciousEndResult",
  sasTokenError: "sasTokenError",
};

export const SCAN_RESULT_TYPE = {
  noThreatsFound: "No threats found",
  malicious: "Malicious",
  failed: "Failed",
};

export const POLLING_API_ERROR = {
  longerThanExpected: "Global.Common.ReloadForFileScan",
  unableToUpload: "Global.Common.FileScanFailed",
};

export const POLLING_API_URL = "/File/FileScanLogEntry";
export const UPDATE_SCAN_STATUS_URL = "/File/UpdateScanStatus";

export const POLLING_INTERVAL_IN_MS = 1000;
export const POLLING_MANUAL_STOP_TIME_IN_MS = 120000;

export const FILE_SCAN_URLS = {
  pollingUrl: "FileScanLogEntry",
  sasTokenUrl: "GetSASTokenAndCreateUploadRow",
};

export const SAS_URL = "/File/GetSASTokenAndCreateUploadRow";

export const CREATE_SAS_FILE_UPLOAD = "/File/CreateSASURIAndUploadFile";

export const SAS_UPLOAD_THROUGH_SERVER = "processThroughServer";